import { FamiliaDoProduto } from "@/models"
import { AxiosRequestConfig } from "axios"
import { Inject } from "inversify-props"
import type { FamiliaDoProdutoServiceAdapter } from "./adapter/FamiliaDoProdutoServiceAdapter"

export class SaveFamiliaDoProdutoUseCase {
	@Inject('FamiliaDoProdutoServiceAdapter')
	private tipoService!: FamiliaDoProdutoServiceAdapter

	criarFamiliaDoProduto = async (familiaDoProduto: FamiliaDoProduto) => await this.tipoService.criarFamiliaDoProduto(familiaDoProduto)

	editarFamiliaDoProduto = async (familiaDoProduto: FamiliaDoProduto) => await this.tipoService.editarFamiliaDoProduto(familiaDoProduto)

	listarFamiliasDoProduto = async (params: any, config?: AxiosRequestConfig) => await this.tipoService.listarFamiliasDoProduto(params, config)
}